/**
 * Decision-sentence helpers.
 *
 * Builds the deterministic "<Actor> (<Role>) <verb> <Nd> <Type> leave for
 * <Employee>." line rendered on each Activity timeline row (TimelineRow in
 * LeaveDetailPage). Same inputs → same string, so automated tests can pin the
 * exact wording.
 *
 * These were extracted from the former Zone5AuditHook module: the "This
 * approval will record" preview UI it powered was removed from the approval
 * surface (replaced by a free-text approval note), but the sentence formatter
 * it shared with the timeline lives on here.
 */

export function ordinalDays(days: number): string {
  if (Number.isInteger(days)) return `${days}d`
  return `${days.toFixed(1)}d`
}

export function humanRole(role: string): string {
  if (role === 'exec_director') return 'Executive Director'
  if (role === 'hod') return 'Head of Department'
  return role.charAt(0).toUpperCase() + role.slice(1)
}

export function humanLeaveType(type: string): string {
  return type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

interface DecisionSentenceProps {
  actorName: string
  actorRole: string
  employeeName: string
  leaveType: string
  days: number
  verb: string
}

export function buildDecisionSentence(props: DecisionSentenceProps): string {
  const { actorName, actorRole, employeeName, leaveType, days, verb } = props
  return (
    `${actorName} (${humanRole(actorRole)}) ${verb} ` +
    `${ordinalDays(days)} ${humanLeaveType(leaveType)} leave for ${employeeName}.`
  )
}
